import { render, staticRenderFns } from "./IcBookmarkOff.vue?vue&type=template&id=55553d30&scoped=true"
import script from "./IcBookmarkOff.vue?vue&type=script&lang=js"
export * from "./IcBookmarkOff.vue?vue&type=script&lang=js"
import style0 from "./IcBookmarkOff.vue?vue&type=style&index=0&id=55553d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55553d30",
  null
  
)

export default component.exports